import { useMemo } from 'react'

import Script from 'next/script'

import CryptoJS from 'crypto-js'

import env from 'src/envs'

import { useAuth } from '../../hooks/useAuth'
import { idToLanguageMap } from '../../context/constants'

export const CCSupportScripts = () => {
  const { user } = useAuth()

  const langCode = useMemo(() => {
    return user?.portal?.language_id ? idToLanguageMap[user?.portal?.language_id] : 'en'
  }, [user?.portal?.language_id])

  const hmac256 = CryptoJS.HmacSHA256(user?.email ? user?.email : '', `${env.intecomWidgetToken}`).toString(
    CryptoJS.enc.Hex
  )

  const key = 'ja31dypv'

  return (
    <Script id='intercom-widget'>
      {`
      (function() {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
            ic('reattach_activator');
            ic('update', w.intercomSettings);
        } else {
          var d = document;
          var i = function() {
              i.c(arguments);
          };
          i.q = [];
          i.c = function(args) {
              i.q.push(args);
          };
          w.Intercom = i;
          var l = function() {
              var s = d.createElement('script');
              s.type = 'text/javascript';
              s.async = true;
              s.src = 'https://widget.intercom.io/widget/` +
        key +
        `';
              var x = d.getElementsByTagName('script')[0];
              x.parentNode.insertBefore(s, x);
          };
          if (document.readyState === 'complete') {
              l();
          } else if (w.attachEvent) {
              w.attachEvent('onload', l);
          } else {
              w.addEventListener('load', l, false);
          }
        }
      })();
      window.intercomSettings = {
        app_id: '` +
        key +
        `',
        alignment: 'right',
        vertical_padding: 100,
        email: '` +
        user?.email +
        `',
        user_id: '` +
        user?.id +
        `',
        name: '` +
        user?.firstName +
        ' ' +
        user?.lastName +
        `',
        user_hash: '` +
        hmac256 +
        `',
        language_override: '` +
        langCode +
        `'
      };
      if('` +
        user?.id +
        `' === '8566') {
        window.intercomSettings.user_id = 3349;
      }
      window.Intercom('boot', window.intercomSettings);
      `}
    </Script>
  )
}
